module.exports = __webpack_public_path__ + "media/images/home/Footer-2421e5b6c829c278631bba4b1fce8420.png";